Vue.asyncComponent('cms-seo-preview',{
    data() {
        return {
            currentPlaceholders: []
        }
    },
    props: {
        id: {
            type: String,
            default: '',
            required: true,
        },
        previewType: {
            type: String,
            required: true
        },
        url: {
            type: String,
        },
        title: {
            type: String|Array,
        },
        description: {
            type: String|Array,
        },
        image: {
            type: String
        },
        placeholders: {
            type: Object|Array,
        }
    },
    computed: {
        /**
         * For google preview we render the host different then the path
         * @returns {string}
         */
        hostAndProtocol() {
            if (! this.url) {
                return null;
            }

            const url = (new URL(this.url));
            return url.protocol + '://' + url.host;
        },
        /**
         * For google preview we render the host different then the path
         * @returns {string}
         */
        host() {
            if (! this.url) {
                return null;
            }
            const url = (new URL(this.url));
            return url.host;
        },

        /**
         * For google preview we render the path different then the host
         * @returns {string}
         */
        path() {
            if (! this.url) {
                return null;
            }

            const url = (new URL(this.url));
            return url.pathname.replace('/', ' › ');
        },
        /**
         * Get the current placeholder set
         * @return {*|*[]}
         */
        placeholderSet() {
            if (! this.currentPlaceholders) {
                return [];
            }

            // we check if we habe a value prop this is for the new placeholder handling flow
            // if it is not there we get the values inside the placeholders
            const placeholderValues = this.currentPlaceholders.values ?
                    this.currentPlaceholders.values :
                    this.currentPlaceholders;

            return this.getPlaceholderValue([], placeholderValues);
        },
    },
    methods: {
        /**
         * Get the placeholders in one object
         * @param out
         * @param placeholders
         * @param activeKey
         * @returns {*}
         */
        getPlaceholderValue(out, placeholders, activeKey = null) {
            for(const propperty in placeholders) {
                let currentActiveKey = activeKey ? activeKey : '';
                const value = placeholders[propperty];
                currentActiveKey += currentActiveKey ? `.${propperty}` : propperty;

                if (typeof value !== 'object') {
                    out.push({
                        value: value,
                        label: currentActiveKey
                    });
                    continue;
                }

                this.getPlaceholderValue(out, value, currentActiveKey);
            }

            return out;
        },
        /**
         * Replace placeholders
         * @param text
         * @return {*}
         */
        replacePlaceholders(text) {
            if (! text) {
                return text;
            }

            this.placeholderSet.forEach( placeholder => {
                text = text.replaceAll('%{' + placeholder.label + '}', placeholder.value);
            })

            return text;
        },
        /**
         * Get the current title
         * @return {string|null}
         */
        currentTitle() {
            if ( ! this.title) {
                return null;
            }
            
            // check if we have a localized value
            const title = typeof this.title === 'object' ?
                    this.title[this.$localeHandler.getActiveLocale()] :
                    this.title;

            return this.replacePlaceholders(title);
        },
        /**
         * Get the current description
         * @return {string|null}
         */
        currentDescription() {
            if ( ! this.description) {
                return null;
            }

            // check if we have a localized value
            const description = typeof this.description === 'object' ?
                    this.description[this.$localeHandler.getActiveLocale()] :
                    this.description;

            return this.replacePlaceholders(description);
        }
    },
    created() {
        this.currentPlaceholders = this.placeholders;
    }
}, 'cms/seo/cms-seo-preview.html');